import { render, staticRenderFns } from "./Impedimento.vue?vue&type=template&id=128134c8"
import script from "./Impedimento.vue?vue&type=script&lang=js"
export * from "./Impedimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports